import React, { useContext } from 'react';
import {
  JobCategoryList,
  JobCompany,
  JobContractPeriod,
  JobEarliestEntryDate,
  JobLocationList,
  JobOrgUnit,
  JobTargetGroupList,
  JobWorkingTimeList,
} from '../jobs/components/job-properties-list';
import { CardContent, CardContentConfig } from '../config/types/config';
import { StateContext } from '../state/contexts';
import Job from '../jobs/types/job';
import { objectEntries } from '../utils/utils';

type Properties = {
  job: Job;
  withIcon?: boolean;
};
const useSortedCardcontent = () => {
  const state = useContext(StateContext);
  const { config } = state;
  const { cardContent } = config.config;

  const cardContentKeyToComponent: Record<keyof CardContent<CardContentConfig>, React.ComponentType<Properties>> = {
    categories: JobCategoryList,
    locations: JobLocationList,
    targetGroups: JobTargetGroupList,
    workingTimes: JobWorkingTimeList,
    contractPeriod: JobContractPeriod,
    earliestEntryDate: JobEarliestEntryDate,
    company: JobCompany,
    orgUnit: JobOrgUnit,
  };

  const sortedCardContentEntries = objectEntries(cardContent)
    .filter(([, value]) => value.enabled)
    .sort((a, b) => {
      const orderA = a[1].order;
      const orderB = b[1].order;
      if (orderA === undefined && orderB === undefined) return 0;
      if (orderA === undefined) return 1;
      if (orderB === undefined) return -1;
      return orderA - orderB;
    });

  const sortedCardContent = Object.fromEntries(sortedCardContentEntries);

  return { sortedCardContent, cardContentKeyToComponent, sortedCardContentEntries };
};

export default useSortedCardcontent;
